class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.autoCloseDelay = 4000;
    this.autoCloseRemaining = this.autoCloseDelay;
    this.autoCloseStartedAt = 0;
    this.autoCloseTimer = null;
    this.isPointerInside = false;
    this.isFocusInside = false;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.notification.addEventListener('pointerenter', () => {
      this.isPointerInside = true;
      this.pauseAutoClose();
    });
    this.notification.addEventListener('pointerleave', () => {
      this.isPointerInside = false;
      this.resumeAutoClose();
    });
    this.notification.addEventListener('focusin', (evt) => {
      if (evt.target === this.notification) return;
      this.isFocusInside = true;
      this.pauseAutoClose();
    });
    this.notification.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        this.isFocusInside =
          this.notification.contains(document.activeElement) && document.activeElement !== this.notification;
        this.resumeAutoClose();
      });
    });
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    this.startAutoClose();
  }

  close() {
    this.clearAutoClose();
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement, this.notification);
  }

  disconnectedCallback() {
    this.clearAutoClose();
    document.body.removeEventListener('click', this.onBodyClick);

    if (this.notification.classList.contains('active')) {
      this.notification.classList.remove('active');
      removeTrapFocus(this.activeElement, this.notification);
    }
  }

  startAutoClose() {
    this.clearAutoClose();
    this.isPointerInside = this.notification.matches(':hover');
    this.isFocusInside =
      this.notification.contains(document.activeElement) && document.activeElement !== this.notification;
    this.resumeAutoClose();
  }

  pauseAutoClose() {
    if (this.autoCloseTimer === null) return;

    window.clearTimeout(this.autoCloseTimer);
    this.autoCloseTimer = null;
    this.autoCloseRemaining = Math.max(0, this.autoCloseRemaining - (Date.now() - this.autoCloseStartedAt));
  }

  resumeAutoClose() {
    if (
      !this.notification.classList.contains('active') ||
      this.isPointerInside ||
      this.isFocusInside ||
      this.autoCloseTimer !== null
    ) {
      return;
    }

    if (this.autoCloseRemaining <= 0) {
      this.close();
      return;
    }

    this.autoCloseStartedAt = Date.now();
    this.autoCloseTimer = window.setTimeout(() => {
      this.autoCloseTimer = null;
      this.autoCloseRemaining = 0;
      this.close();
    }, this.autoCloseRemaining);
  }

  clearAutoClose() {
    if (this.autoCloseTimer !== null) window.clearTimeout(this.autoCloseTimer);
    this.autoCloseTimer = null;
    this.autoCloseRemaining = this.autoCloseDelay;
    this.autoCloseStartedAt = 0;
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
